/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  AutoComplete,
  Button,
  Col,
  Divider,
  Input,
  Row,
  Select,
  Modal,
  Table,
  Tooltip,
  // Image,
  Typography,
  Switch,
  Skeleton,
  Badge,
  DatePicker,
  // Skeleton,
} from "antd";

import {
  SettingOutlined,
  SearchOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import "./index.css";
// import { TableData } from "./data";
import { Prompt, useHistory } from "react-router";
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
import useBeforeUnload from "../../components/Prompting";
import { useDispatch, useSelector } from "react-redux";
import {
  deletePurchaseList,
  loadPurchaseOrders,
} from "../../store/purchase-orders/actions";
import { BiCalendar } from "react-icons/bi";
import moment from "moment";
import { toast } from "react-toastify";

const PurchaseOrders = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { RangePicker } = DatePicker;
  //state initial
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [selectDays, setSelectDays] = useState([]);
  const [search, setSearch] = useState("");
  const [showOrders, setShowOrders] = useState([]);

  //organisation id from login response

  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const organizationId = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const userId = !isEmpty(userNameDetails) ? userNameDetails.user._id : "";

  console.log(userId, "userId");
  const purchaseList = { organizationId: organizationId };

  //api loader
  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setLoading(false);
      setTableLoading(false);
    }, 2000);
    dispatch(loadPurchaseOrders(purchaseList));
    setShowOrders("Show Open Orders");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  const { parties_list = [] } = useSelector((state) => state.PurchaseOrders);

  console.log(parties_list, "parties_list");
  //States data
  const [invoiceShow, setInvocieShow] = useState(false);
  const [purchaseData, setPurchaseData] = useState({
    prefix: "Prefix",
    seqNo: "",
  });

  const handleChange = (e) => {
    setPurchaseData({
      ...purchaseData,
      [e.target.name]: e.target.value,
    });
  };

  const [searchOpen, setSearchOpen] = useState(false);

  //Custom Fields State values
  const [settingsFieldModal, setSettingsFieldModal] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  // const hasSelected = selectedRowKeys.length > 0;

  const handleOk = () => {
    setSettingsFieldModal(false);
  };
  const handleCancel = () => {
    setSettingsFieldModal(false);
  };

  //header columns
  const HeaderData = [
    {
      key: "poDate",
      title: "Date",
      dataIndex: "poDate",
      sortDirections: ["ascend"],
      sorter: (a, b) => a.poDate.length - b.poDate.length,
      // sortOrder: sortedInfo.columnKey === "date" ? sortedInfo.order : null,
    },
    {
      key: "poNo",
      title: "Order Number",
      // title: "Purchase Order Number",
      dataIndex: "poNo",
    },
    {
      key: "vendorName",
      title: "Party Name",
      dataIndex: "vendorName",
    },
    {
      key: "povalidDate",
      title: "Valid Till",
      dataIndex: "povalidDate",
    },
    {
      key: "NetAmount",
      title: "Amount",
      dataIndex: "NetAmount",
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
    },
  ];

  const purchaseRoutes = (data) => {
    history.push({
      pathname: "/purchase-orders/data",
      state: data,
    });
  };

  //purchase rows

  const [purchaseRows, setPurchaseRows] = useState([
    {
      _id: "",
      key: "",
      NetAmount: "",
      authorizedsignature: "",
      autoamountroundoff: "",
      beforeautoroundoffamount: "",
      charge: "",
      createdAt: "",
      createdBy: "",
      financialyearId: "",
      isHistory: "",
      items: "",
      notes: "",
      organizationId: "",
      poDate: "",
      poNo: "",
      povalidDate: "",
      status: "",
      subtotalamount: "",
      taxableAmonut: "",
      termsandconditions: "",
      totaltax: "",
      totaltaxableValue: "",
      transActionType: "",
      type: "",
      updatedAt: "",
      vendorAddress: "",
      vendorCity: "",
      vendorId: "",
      vendorName: "",
      vendorNameValue: "",
    },
  ]);

  //data table
  const purchaseDataTable =
    parties_list && parties_list.length > 0
      ? parties_list.map((data, index) => {
          const poDateValue = data.poDate ? moment() : 0;
          const poValidTill = data.povalidDate ? moment(data.povalidDate) : 0;

          const validTill = poValidTill.diff(poDateValue, "days");
          console.log(validTill, "validTill");
          // const netAmount = data.NetAmount.replace(/\d(?=(?:\d{3})+$)/g, '$&,');
          // console.log(netAmount, "netAmount")
          return {
            _id: data._id,
            key: index + 1,
            NetAmount: (
              <h1
                className="cursor-pointer"
                onClick={() => purchaseRoutes(data)}
              >
                {"₹ " + data.NetAmount}
              </h1>
            ),
            authorizedsignature: data.authorizedsignature,
            autoamountroundoff: data.autoamountroundoff,
            beforeautoroundoffamount: data.beforeautoroundoffamount,
            charge: data.charge,
            createdAt: data.createdAt
              ? moment(data.createdAt).format("DD-MM-YYYY")
              : "",
            createdBy: data.createdBy,
            financialyearId: data.financialyearId,
            isHistory: data.isHistory,
            items: data.items,
            notes: data.notes,
            organizationId: data.organizationId,
            poDate: (
              <h1
                className="cursor-pointer"
                onClick={() => purchaseRoutes(data)}
              >
                {data.poDate ? moment(data.poDate).format("DD-MM-YYYY") : ""}
              </h1>
            ),
            poNo: (
              <h1
                className="cursor-pointer"
                onClick={() => purchaseRoutes(data)}
              >
                {data.poNo}
              </h1>
            ),
            povalidDate: (
              <h1
                className="cursor-pointer"
                onClick={() => purchaseRoutes(data)}
              >
                <Badge
                  className={
                    data.povalidDate && validTill > 10
                      ? "bg-[#edf6ef] font-semibold rounded-md text-[#49a563] p-2"
                      : "bg-[#f1e7e9] font-semibold rounded-md text-[#d01717] p-2"
                  }
                >
                  {data.povalidDate && validTill > 1
                    ? validTill + " Days"
                    : validTill == 1
                    ? validTill + " Day"
                    : validTill <= 0
                    ? "Expired"
                    : ""}
                </Badge>
              </h1>
            ),
            subtotalamount: data.subtotalamount,
            taxableAmonut: data.taxableAmonut,
            termsandconditions: data.termsandconditions,
            totaltax: data.totaltax,
            totaltaxableValue: data.totaltaxableValue,
            transActionType: data.transActionType,
            type: data.type,
            updatedAt: data.updatedAt,
            vendorAddress: data.vendorAddress,
            vendorCity: data.vendorCity,
            vendorId: data.vendorId,
            vendorName: (
              <h1
                className="cursor-pointer"
                onClick={() => purchaseRoutes(data)}
              >
                {data.vendorName}
              </h1>
            ),
            vendorNameValue: data.vendorName,

            status: (
              <Badge
                className={
                  data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusName === "Active"
                    ? "bg-[#edf6ef] font-semibold rounded-md text-[#49a563] p-2"
                    : "bg-[#f1e7e9] font-semibold rounded-md text-[#d01717] p-2"
                }
              >
                {data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusName}
              </Badge>
            ),
          };
        })
      : [];

  useEffect(() => {
    if (purchaseDataTable && purchaseDataTable.length > 0) {
      setPurchaseRows(purchaseDataTable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parties_list]);

  //data table
  const hasSelected = selectedRowKeys.length > 0;

  const handleSearch = (event) => {
    const filteredRows = purchaseDataTable
      .filter((row) =>
        row.vendorNameValue
          .toLowerCase()
          .includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates

    setSearch(event.target.value);
    setPurchaseRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  console.log(purchaseRows, "purchaseRows");
  const [deletePurchaseModal, setDeletePurchaseModal] = useState(false);

  //deletPurchase api integrations
  const deletePurchaseOrders = () => {
    const itemListData = {
      organizationId: organizationId,
      poId:
        selectedRowKeys.length > 0 ? selectedRowKeys.map((data) => data) : "",
      deletedBy: !isEmpty(userNameDetails) ? userNameDetails.user._id : "",
    };
    dispatch(deletePurchaseList(itemListData));
    setTimeout(() => {
      dispatch(loadPurchaseOrders(purchaseList));
      setDeletePurchaseModal(false);
      toast.error("Purchase orders deleted successfully");
    }, 1000);
  };

  //page load without saving

  useBeforeUnload({
    when: !isEmpty(selectDays),
    message: "Are you sure you want to leave?",
  });

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Purchase Orders | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        {/* <Skeleton.Input
          style={{
            padding: "5px",
            width: "100%",
          }}
          active={true}
          size={"large"}
        > */}
        <Col span={24}>
          <div className="font-poppins flex justify-between pl-[20px] pr-[20px] mt-4">
            <div className="flex">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[18px] mt-2 font-semibold"
              >
                Purchase Orders
              </h1>
            </div>
            <div>
              <Tooltip
                title="Easily add the Purchase Orders settings"
                placement="bottom"
                rootClassName="text-[10px]"
              >
                <div
                  onClick={() => setSettingsFieldModal(true)}
                  className="border rounded-md ml-3 pt-2 pb-2 pl-3 pr-3 cursor-pointer"
                >
                  <SettingOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        </Col>
        {/* purchase input section with bulk actions */}
        <Col span={24} className="purchase-table-orders mt-5 mb-2">
          <Row className="purchase-orders-filters-main ml-4">
            <div className="purchase-orders-filters">
              {loading ? (
                <Skeleton.Input
                  style={{
                    marginRight: "30px",
                    width: "100%",
                    height: "40px",
                  }}
                ></Skeleton.Input>
              ) : (
                <>
                  <Tooltip
                    rootClassName="text-[10px]"
                    title="Search by phone or name"
                    placement="bottom"
                  >
                    {searchOpen ? (
                      <div className="filter-dropdown-filters">
                        <AutoComplete
                          style={{
                            marginRight: "10px",
                          }}
                          onClick={() => setSearchOpen(false)}
                          className="w-[100%]"
                        >
                          <Input.Search
                            size="large"
                            placeholder="Search Party"
                            style={{
                              fontFamily: "Poppins",
                            }}
                            name="search"
                            value={search}
                            onChange={(e) => handleSearch(e)}
                          />
                        </AutoComplete>
                      </div>
                    ) : (
                      <div
                        onClick={() => setSearchOpen(true)}
                        className="filter-dropdown-search-filters border rounded-md h-[40px] mr-3 pt-2 pb-2 pr-3 pl-3 cursor-pointer"
                      >
                        <SearchOutlined size={16} />
                      </div>
                    )}
                  </Tooltip>

                  <div
                    style={{
                      marginRight: "0.75rem",
                      marginLeft: searchOpen ? "0.75rem" : "0rem",
                    }}
                    className="filter-dropdown-filters"
                  >
                    <RangePicker
                      style={{
                        width: "100%",
                        height: 40,
                        fontFamily: "Poppins",
                      }}
                      placeholder="Select Days"
                      // value={selectDays}
                      onChange={(date, dateString) => {
                        console.log(date, "date");
                        setSelectDays(dateString);
                      }}
                      options={[]}
                      className="mr-3"
                      allowClear
                      suffixIcon={<BiCalendar size={14} />}
                    />
                  </div>
                </>
              )}

              {loading ? (
                <Skeleton.Input
                  style={{
                    marginLeft: "30px",
                    width: "120%",
                    height: "40px",
                  }}
                ></Skeleton.Input>
              ) : (
                <div className="filter-dropdown-filters">
                  <Select
                    style={{
                      width: "100%",
                      height: 40,
                      fontFamily: "Poppins",
                    }}
                    value={showOrders}
                    onChange={(e) => setShowOrders(e)}
                    defaultValue={"Show Open Orders"}
                    placeholder="Select Orders"
                    options={[
                      {
                        label: "Show All Orders",
                        value: "Show All Orders",
                      },
                      {
                        label: "Show Open Orders",
                        value: "Show Open Orders",
                      },
                      {
                        label: "Show Closed Orders",
                        value: "Show Closed Orders",
                      },
                    ]}
                  />
                </div>
              )}
            </div>
            <div className="flex">
              {loading ? (
                <Skeleton.Input
                  style={{
                    paddingRight: "25px",
                    marginRight: "25px",
                    width: "90%",
                    height: "40px",
                  }}
                ></Skeleton.Input>
              ) : (
                <Button
                  // onClick={() => {
                  //   toast.success("purchase Created");
                  // }}
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className={
                    searchOpen
                      ? "create-purchase-orders-button"
                      : "create-purchase-orders-search-button"
                  }
                >
                  <Link
                    to={{
                      pathname: "/create-purchase-orders",
                      state:
                        parties_list && parties_list.length > 0
                          ? parties_list.length
                          : 1,
                    }}
                  >
                    Create Purchase Orders
                  </Link>
                </Button>
              )}
            </div>
          </Row>
        </Col>
        <Col span={24} className="pl-4 pr-4 pt-3 pb-1">
          {hasSelected ? (
            <Row className="flex justify-between mb-2">
              <Col
                style={{
                  fontFamily: "Poppins",
                  color: "#ffffff",
                  background: "#4096ff",
                  borderRadius: "10px",
                  padding: "5px 10px",
                }}
                className="mb-1"
                span={4}
              >
                {hasSelected ? `Selected ${selectedRowKeys.length} items` : ""}
              </Col>
              {selectedRowKeys.length > 0 ? (
                <Col>
                  <Tooltip title="Delete purchase orders" placement="topLeft">
                    <div
                      onClick={() => setDeletePurchaseModal(true)}
                      className="cursor-pointer border border-1 p-[8px] rounded-md"
                    >
                      <DeleteOutlined className="text-[#eb4e50] text-[16px]" />
                    </div>
                  </Tooltip>
                </Col>
              ) : (
                ""
              )}
            </Row>
          ) : (
            ""
          )}
        </Col>
        <Col span={24} className="p-4 purchase-table-orders">
          <Table
            style={{
              overflow: "hidden",
            }}
            bordered
            columns={HeaderData}
            dataSource={
              purchaseRows &&
              purchaseRows.length > 0 &&
              !isEmpty(purchaseRows[0].vendorNameValue)
                ? purchaseRows
                : []
            }
            // onChange={onChange}
            sortDirections={"ascend"}
            loading={tableLoading ? true : false}
            showSorterTooltip={"sorter-icon"}
            rowKey={(record) => record._id}
            rowSelection={{
              selectedRowKeys,
              onSelectAll: (selectedRowKeys, selectedRows, row) => {
                const newSelecteds = selectedRows.map((n) => n._id);
                setSelectedRowKeys(newSelecteds);
              },
              onSelect: (selectedRowKey, selectedRows, row) => {
                const selectedIndex = selectedRowKeys.indexOf(
                  selectedRowKey._id
                );
                let newSelecteds = [];

                if (selectedIndex === -1) {
                  newSelecteds = newSelecteds.concat(
                    selectedRowKeys,
                    selectedRowKey._id
                  );
                } else if (selectedIndex === 0) {
                  newSelecteds = newSelecteds.concat(selectedRowKeys.slice(1));
                } else if (selectedIndex === selectedRowKeys.length - 1) {
                  newSelecteds = newSelecteds.concat(
                    selectedRowKeys.slice(0, -1)
                  );
                } else if (selectedIndex > 0) {
                  newSelecteds = newSelecteds.concat(
                    selectedRowKeys.slice(0, selectedIndex),
                    selectedRowKeys.slice(selectedIndex + 1)
                  );
                }
                setSelectedRowKeys(newSelecteds);
              },
            }}
            scroll={{ y: 190, x: 765 }}
          />
        </Col>
        {/* Custom fields modal */}
        <Modal
          open={settingsFieldModal}
          title="Quick Purchase Orders Settings"
          onOk={handleOk}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          onCancel={handleCancel}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
          <Col span={24}>
            <div className="w-[100%] flex justify-between mb-2 mt-[-15px]">
              <h1 className="purchase-label text-[16px]">
                Purchase Orders Prefix & Invoice Number
              </h1>
              <Switch
                value={invoiceShow}
                onChange={(checked) => setInvocieShow(checked)}
              />
            </div>
            {invoiceShow ? (
              <Row className="mt-2">
                <Col span={8} className="pr-3">
                  <Typography className="mb-1">Prefix</Typography>

                  <Input
                    name="prefix"
                    value={purchaseData.prefix}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Prefix"
                    className="p-2"
                  />
                </Col>
                <Col span={8}>
                  <Typography className="mb-1">Sequence Number</Typography>

                  <Input
                    name="seqNo"
                    value={purchaseData.seqNo}
                    onChange={(e) => handleChange(e)}
                    placeholder="Enter Seq No"
                    className="p-2"
                  />
                </Col>
                <Col span={24} className="mt-2">
                  <Typography className="mb-1">
                    Purchase Orders Number:{" "}
                    {!isEmpty(purchaseData.seqNo) ? purchaseData.seqNo : ""}
                  </Typography>
                </Col>
              </Row>
            ) : (
              ""
            )}
          </Col>

          <Divider
            style={{ borderWidth: "0.2px", width: "110%", marginLeft: "-24px" }}
          />
        </Modal>
      </Row>
      {/* Delete purchase modal */}

      <Modal
        open={deletePurchaseModal}
        onOk={() => {
          deletePurchaseOrders();
        }}
        closeIcon
        maskClosable={false}
        okText={`Delete ${
          selectedRowKeys.length > 0 ? selectedRowKeys.length : ""
        } PO`}
        cancelText={"Cancel"}
        okType="danger"
        onCancel={() => setDeletePurchaseModal(false)}
        height={300}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <CancelBtn />
            <div className="ml-3">
              <OkBtn />
            </div>
          </div>
        )}
      >
        <div className="text-center w-[100%] p-7">
          <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
          <h1 className="text-center text-[18px] font-bold">
            Are you sure you want to delete these purchase?
          </h1>
          <p className="text-center text-[14px] mt-2">
            The selected purchase will be deleted from the purchase Inventory.
            Once deleted you will not be able to restore these purchase.
          </p>
        </div>
      </Modal>
      <Prompt
        when={!isEmpty(selectDays)}
        message="Are you sure you want to leave?"
      />
      {/* <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      /> */}
    </React.Fragment>
  );
};

export default PurchaseOrders;
